"use client";

import { c as _c } from "react/compiler-runtime";
import { useTheme } from "next-themes";
import type { CSSProperties } from "react";
import type { ClientTheme } from "@/lib/theme-resolver";
import { toCssVars } from "@/lib/theme-resolver";
interface ClientThemeProviderProps {
  theme: ClientTheme | null;
  children: React.ReactNode;
  className?: string;
}

/**
 * Applies an OAuth client's theme by setting CSS custom properties on a
 * wrapper element. Uses the ThemeToken's light/dark styles directly —
 * the same property mapping as the SDK's applyTheme().
 *
 * When theme is null, renders a transparent passthrough wrapper.
 */
export function ClientThemeProvider(t0) {
  const $ = _c(7);
  const {
    theme,
    children,
    className
  } = t0;
  const {
    resolvedTheme
  } = useTheme();
  const mode = resolvedTheme === "dark" ? "dark" : "light";
  let t1;
  if ($[0] !== mode || $[1] !== theme) {
    t1 = theme ? toCssVars(theme.token.styles[mode]) : {};
    $[0] = mode;
    $[1] = theme;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const vars = t1;
  const t2 = vars as unknown as CSSProperties;
  let t3;
  if ($[3] !== children || $[4] !== className || $[5] !== t2) {
    t3 = <div className={className} style={t2}>{children}</div>;
    $[3] = children;
    $[4] = className;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}